import { all, Div, H3, Mark, reactive, Span, VArray } from 'alkali'
import { get, post } from 'tools/request'
import Dropdown from 'components/generic/Dropdown'
import * as closeIcon from 'icons/close.svg'
import Icon from 'components/Icon'
import { liveStructuredQuery, liveParsed, liveQuestion } from 'model/SearchQuery'
import { renderQuestion } from './Question'
import './SuggestionDropdown.css'

export class SuggestionDropdown extends Div('.suggestion-dropdown') {
	created(properties) {
		properties.content = properties.suggestions.to(suggestions => {
			const useSuggestion = (suggestion, executeSearch?) => {
				liveParsed.annotations.put(suggestion.annotations)
				liveParsed.selectionsId.put(suggestion.selectionsId)
				liveParsed.interventionalScore.put(suggestion.interventionalScore)
				liveQuestion.position.put(null)
				if (executeSearch)
					this.searchTarget.searchOnRender = true
			}
			return suggestions.map(suggestion => Div('.suggestion', {
				content: renderQuestion(suggestion.annotations),
				onmousedown() {
					this.useSuggestion(true)
				},
				useSuggestion: (executeSearch?) => {
					useSuggestion(suggestion, executeSearch)
				},
			}))
		}).as(VArray)
	}
	show(event, target) {
		this.visible = true
		this.currentIndex = -1
		this.targetElement = target
		event.target = target
		this.searchInput = event.searchInput
		this.searchTarget = event.searchComponent
	}
	currentIndex = -1
	initialQuestion
	cursorUp() {
		this.preserveInitialQuestion()
		this.currentIndex -= 1
		this.updateSelectedSuggestion(() => this.currentIndex = this.childNodes.length - 1)
	}
	cursorDown() {
		this.preserveInitialQuestion()
		this.currentIndex += 1
		this.updateSelectedSuggestion(() => this.currentIndex = -1)
	}
	updateSelectedSuggestion(loop: Function) {
		const useInitialQuestion = {
			useSuggestion: () => {
				liveParsed.annotations.put(this.initialQuestion.annotations)
				liveParsed.interventionalScore.put(this.initialQuestion.interventionalScore)
				liveQuestion.put(this.initialQuestion)
			}
		}
		let newSelection = this.currentIndex == -1 ? useInitialQuestion : this.childNodes[this.currentIndex]
		if (!newSelection)
			loop()
		newSelection = this.currentIndex == -1 ? useInitialQuestion : this.childNodes[this.currentIndex]
		if (!newSelection)
			return

		let previousSelection = this.querySelector('.selected-suggestion')
		if (previousSelection?.classList)
			previousSelection.classList.remove('selected-suggestion')
		newSelection.classList?.add('selected-suggestion')
		newSelection.useSuggestion()
	}
	preserveInitialQuestion() {
		if (!this.initialQuestion) {
			this.initialQuestion = this.searchTarget.getCurrentQuestion()
		}
	}
	resetCursor() {
		this.currentIndex = -1
		this.initialQuestion = null
	}
}

